import { useEffect } from "react";
import { InteractionStatus } from "@azure/msal-browser";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import type { ReactNode } from "react";
import { loginRequest } from "@/features/auth/authConfig";

interface ProtectedRouteProps {
  children: ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const isAuthenticated = useIsAuthenticated();
  const { instance, inProgress } = useMsal();

  useEffect(() => {
    if (!isAuthenticated && inProgress === InteractionStatus.None) {
      void instance.loginRedirect(loginRequest);
    }
  }, [instance, isAuthenticated, inProgress]);

  if (inProgress !== InteractionStatus.None) {
    return <p className="p-6 text-slate-700">Signing in...</p>;
  }

  if (!isAuthenticated) {
    return <p className="p-6 text-slate-700">Redirecting to sign-in...</p>;
  }

  return <>{children}</>;
}
